import * as types from './mutation-types'
import {createFormData} from "@/mixins/Helpers";

export const getFormTypes = ({ commit, dispatch, state }) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/participantType/collection').then((response) => {
            commit(types.FORMS_TYPES_SUCCESS, response.data)
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
} 

export const getEventForms = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/'+id+'/event/forms').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
} 

export const getTypeDefaultForm = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/event/form', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
} 



export const saveEventForm = ({ commit, dispatch, state }, data) => {
    return new Promise((resolve, reject) => {
        window.axios
            .patch(`update/${data.id}/event/form`, data)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const getEventForm = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios
            .get(`get/${id}/event/form`)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};

export const deleteEventForm = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios
            .delete(`delete/${id}/event/form`, id)
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
};


export const getEventFormsForParticipator = ({ commit, dispatch, state }, id) => {
    return new Promise((resolve, reject) => {
        window.axios.get('get/'+ id +'/event/form').then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const registerParticipator = ({commit}, data) => {
    let formSubmit = createFormData(data)
    return new Promise((resolve, reject) => {
        window.axios.post('store/invitation/response', formSubmit).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const sendContact = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('send/form/contact', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

export const submitGoogleFormInscription = ({commit}, data) => {
    return new Promise((resolve, reject) => {
        window.axios.post('store/senapkon/event/'+data.id+'/invitation', data).then((response) => {
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}